import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'keepInTouch/templates';

/** The caller's private templates plus every account-shared one. */
export function useKeepInTouchTemplatesQuery({
	enabled = true,
	meta = { toastErrorMessage: 'Failed to load Keep In Touch configurations' },
}: {
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
} = {}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => userSession.webServiceHelper.callAsync<Api.KeepInTouchTemplate[]>('keepInTouch/templates', 'GET'),
		queryKey: [BASE_QUERY_KEY],
		meta,
	});
}

export const invalidateKeepInTouchTemplatesQueries = () =>
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });

export const updateKeepInTouchTemplatesRQCache = (updatedTemplate: Api.KeepInTouchTemplate) => {
	reactQueryClient.setQueryData<Api.KeepInTouchTemplate[]>([BASE_QUERY_KEY], oldTemplates => {
		if (!oldTemplates) {
			return [updatedTemplate];
		}
		const index = oldTemplates.findIndex(t => t.id === updatedTemplate.id);
		if (index === -1) {
			return [...oldTemplates, updatedTemplate];
		}
		const newTemplates = [...oldTemplates];
		newTemplates[index] = updatedTemplate;
		return newTemplates;
	});
};
